
import React from 'react'
import ContentLayout from '../shared/ContentLayout';
import SupportingDocumentsNavbar from './SupportingDocumentsNavbar';

const SupportingDocumentsLayout = ({campaign, user, children}) => {
  return (
    <div>
      <div className="navbar-content-info">
        <SupportingDocumentsNavbar campaign={campaign} user={user} />
        <div className= "template">
          {children}
        </div>
      </div>
    </div>
  )
}

export default SupportingDocumentsLayout
